import { render, staticRenderFns } from "./circle.vue?vue&type=template&id=08883fec&"
import script from "./circle.vue?vue&type=script&lang=js&"
export * from "./circle.vue?vue&type=script&lang=js&"
import style0 from "./circle.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports